import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jsmWorkItemIncidentEmbedRoute: InvariantJiraRoute = {
	name: 'jsm-work-item-incident-embed',
	path: '/jira/servicedesk/incidents/:issueKey(\\w+-\\d+)/embed',
	exact: true,
};
